/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddUpdateLotModal_lot$ref: FragmentReference;
declare export opaque type AddUpdateLotModal_lot$fragmentType: AddUpdateLotModal_lot$ref;
export type AddUpdateLotModal_lot = {|
  +id: string,
  +lotNumber: string,
  +binNumber: ?string,
  +expiresAt: ?any,
  +warehouseLocation: ?{|
    +id: string,
    +name: string,
  |},
  +$refType: AddUpdateLotModal_lot$ref,
|};
export type AddUpdateLotModal_lot$data = AddUpdateLotModal_lot;
export type AddUpdateLotModal_lot$key = {
  +$data?: AddUpdateLotModal_lot$data,
  +$fragmentRefs: AddUpdateLotModal_lot$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AddUpdateLotModal_lot",
  "type": "Lot",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lotNumber",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "binNumber",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "expiresAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "warehouseLocation",
      "storageKey": null,
      "args": null,
      "concreteType": "WarehouseLocation",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '54f6b6257a41fa582d40f5197c8d8349';
module.exports = node;
